import { render, staticRenderFns } from "./PoolAssetIcon.vue?vue&type=template&id=123d517e&scoped=true"
import script from "./PoolAssetIcon.vue?vue&type=script&lang=js"
export * from "./PoolAssetIcon.vue?vue&type=script&lang=js"
import style0 from "./PoolAssetIcon.vue?vue&type=style&index=0&id=123d517e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d517e",
  null
  
)

export default component.exports